/**
 * DateField — date picker overlay for signing ceremony
 * Defaults to today's date and auto-populates on mount
 */

import { useEffect } from 'react';
import type { FieldPlacement } from './types';

interface DateFieldProps {
  placement: FieldPlacement;
  value: string | null;
  onChange: (iso: string) => void;
  fieldIndex: number;
}

function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function DateField({ value, onChange, fieldIndex }: DateFieldProps): JSX.Element {
  useEffect(() => {
    if (!value) {
      onChange(todayIso());
    }
  // Only run on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      type="date"
      data-testid={`date-field-${fieldIndex}`}
      value={value ?? todayIso()}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Select date"
      className="w-full h-full px-1 py-0.5 text-xs border border-primary/60 rounded bg-card focus:outline-none focus:ring-2 focus:ring-ring min-h-[44px]"
    />
  );
}

export default DateField;
